import { Component } from "react"
import PropTypes from "prop-types"

import SuccessLottieAnimation from "./success_lottie_animation"

import classnames from "classnames"
import Fittty from "shared/components/fittty"
import colors from "foundation/_colors_export.scss?export"
import { ctaCopyToConnect } from "../utils"
import { expireBFCache } from "shared/scripts/back_forward_cache_utils"

export default class ConnectButton extends Component {
  state = {
    connected: false,
    playEnableAnimation: false,
    playHalfEnableAnimation: false,
    playMeterAnimation: false,
    playSuccessAnimation: false,
    ctaCopy: this.props.ctaCopy,
    showKnob: this.props.showKnob,
    knobBgColor: {
      backgroundColor: `#${this.props.mainService.brand_color}`,
    },
    willConnect: false,
  }

  render() {
    const {
      playEnableAnimation,
      playMeterAnimation,
      playHalfEnableAnimation,
      playSuccessAnimation,
      connected,
      ctaCopy,
      showKnob,
      knobBgColor,
      willConnect,
    } = this.state

    const { knobBgColorForDarkBrands, defaultBgColor, dynamicConfig, mainService } = this.props

    const buttonBgColor = showKnob
      ? defaultBgColor // displays in primaryTextColor
      : knobBgColor // or it's about the service hence takes the service color

    const showKnobStyle = showKnob ? { opacity: 1 } : { opacity: 0 }

    return (
      <div className="connect-button-outline ca">
        <div style={buttonBgColor} className="connect-button" onClick={this.handleClick}>
          {playSuccessAnimation && <SuccessLottieAnimation />}
          <div className="meter-container">
            <div
              id="progress-meter"
              className={classnames({
                meter: playMeterAnimation,
              })}
            />
          </div>
          <div
            id="connect-ball"
            className={classnames("service-icon", {
              "alt-brand-color": knobBgColorForDarkBrands,
              "slide-out": playEnableAnimation,
              "slide-out-from-middle": playHalfEnableAnimation,
              "will-connect": willConnect,
              "did-slide": !playEnableAnimation && playMeterAnimation,
              "will-slide-from-middle": playSuccessAnimation,
              connected,
            })}
            style={{ ...knobBgColor, ...showKnobStyle }}
          >
            {dynamicConfig && (
              <img
                src={mainService.lrg_monochrome_image_url || mainService.lrg_variant_image_url}
                width="40"
                height="40"
                alt={mainService.name}
                title={mainService.name}
              />
            )}
          </div>
          <div
            className={classnames("connect-cta", {
              connected,
              "fade-out": playEnableAnimation,
              "opacity-1": !playEnableAnimation,
            })}
          >
            <div className={classnames({ "no-knob": playMeterAnimation })}>
              <Fittty maxSize={this.props.connectButtonMaxFontSize} minSize={14} text={ctaCopy} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleClick = event => {
    event.preventDefault()
    expireBFCache()
    this.props.onConnectClick()
  }

  componentDidMount() {
    if (this.props.connected && !this.state.connected) {
      this.latch()
    } else {
      this.showConnectedState()
    }
  }

  handleKnobAnimationEnd = () => {
    this.meterElement = document.querySelector("#progress-meter")
    this.setState(
      {
        ctaCopy: `Connecting ${this.props.mainService.short_name}`,
        playMeterAnimation: true,
        playEnableAnimation: false,
        showKnob: false,
        connected: false,
      },
      () => {
        this.meterElement.addEventListener("transitionend", this.handleMeterAnimationEnd)
        this.knobElement.removeEventListener("transitionend", this.handleKnobAnimationEnd)
      }
    )
  }

  handleMeterAnimationEnd = () => {
    this.setState(
      {
        playMeterAnimation: false,
        playEnableAnimation: false,
        playSuccessAnimation: true,
        ctaCopy: "",
        showKnob: false,
      },
      () => {
        setTimeout(
          () =>
            this.setState({
              playSuccessAnimation: false,
              playHalfEnableAnimation: true,
              ctaCopy: "Connected",
              playMeterAnimation: false,
              showKnob: true,
              connected: true,
            }, () => {
              this.knobElement.addEventListener("animationend", this.handleHalfEnableAnimationEnd)
            }),
          this.props.successConnectionDelay
        )
      }
    )

    this.meterElement.removeEventListener("transitionend", this.handleMeterAnimationEnd)
  }

  handleHalfEnableAnimationEnd = () => {
    this.setState({
      playHalfEnableAnimation: false,
      willConnect: false,
    }, () => {
      this.knobElement.removeEventListener("animationend", this.handleHalfEnableAnimationEnd)
    })
  }

  showConnectedState = () => {
    this.setState({
      connected: true,
      playEnableAnimation: false,
      ctaCopy: "Connected",
    })
  }

  latch = () => {
    // don't play aninmations if the flow has not been started in this "session"
    if (this.props.connectClicked) {
      this.knobElement = document.querySelector("#connect-ball")
      this.setState({ willConnect: true }, () => {
        requestAnimationFrame(() => {
          this.setState(
            {
              connected: false,
              playEnableAnimation: true,
              showKnob: true,
              ctaCopy: ctaCopyToConnect(this.props.dynamicConfig && this.props.mainService.short_name),
            },
            () => {
              this.knobElement.addEventListener("transitionend", this.handleKnobAnimationEnd)
            }
          )
        })
      })
    } else {
      this.showConnectedState()
    }
  }
}

ConnectButton.propTypes = {
  connectClicked: PropTypes.bool.isRequired,
  mainService: PropTypes.object.isRequired,
  onConnectClick: PropTypes.func.isRequired,
  showKnob: PropTypes.bool,
  ctaCopy: PropTypes.string,
  connected: PropTypes.bool,
  dynamicConfig: PropTypes.bool,
  successConnectionDelay: PropTypes.number,
  defaultBgColor: PropTypes.object,
  knobBgColorForDarkBrands: PropTypes.bool,
  connectButtonMaxFontSize: PropTypes.number,
}

ConnectButton.defaultProps = {
  ctaCopy: "Connect",
  defaultBgColor: { backgroundColor: colors.primaryTextColor },
  successConnectionDelay: 1500,
  connected: false,
  connectButtonMaxFontSize: 30,
}
